export const sharedPipes: any[] = [];
